import styled from 'styled-components';

export const CardItemTitle = styled.h2`
  font-family: ${props => props.theme.fonts.circular} !important;
  color: ${props => props.theme.colors.capsuleGreen60} !important;
  font-size: ${props => props.theme.fontSizes.small} !important;
  font-weight: ${props => props.theme.fontWeights.semiBold} !important;
  letter-spacing: ${props => props.theme.letterSpacings.one} !important;
  text-transform: uppercase !important;
`;

export const CardErrorTitle = styled.h2`
  font-family: ${props => props.theme.fonts.circular} !important;
  color: ${props => props.theme.colors.capsuleRed70} !important;
  font-size: ${props => props.theme.fontSizes.small} !important;
  font-weight: ${props => props.theme.fontWeights.semiBold} !important;
  letter-spacing: ${props => props.theme.letterSpacings.one} !important;
  text-transform: uppercase !important;
`;

export const CardItemInfoText = styled.p<{ shouldBold: boolean }>`
  font-family: ${props => props.theme.fonts.circular} !important;
  color: ${props => props.theme.colors.capsuleBlue50} !important;
  font-size: ${props => props.theme.fontSizes.body} !important;
  font-weight: ${props => (props.shouldBold ? props.theme.fontWeights.bold : props.theme.fontWeights.book)} !important;
  letter-spacing: ${props => props.theme.letterSpacings.normal} !important;
  line-height: ${props => props.theme.lineHeights.body} !important;
  padding: 0 ${props => props.theme.space['1.0']} !important;
`;

export const TextAndIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
`;
